import { createSlice } from "@reduxjs/toolkit";

const passiveLoadSlice = createSlice({
  name: "passiveLoad",
  initialState: {
    data: null,
    isFetching: false,
    error: null,
  },
  reducers: {
    passiveLoadStart: (state) => {
      state.isFetching = true;
      state.error = null;
    },
    passiveLoadSuccess: (state, action) => {
      state.isFetching = false;
      state.data = action.payload;
      state.error = null;
    },
    passiveLoadFailure: (state, action) => {
      state.isFetching = false;
      state.error = action.payload || "Error loading passive load data";
    },
  },
});

export const { passiveLoadStart, passiveLoadSuccess, passiveLoadFailure } =
  passiveLoadSlice.actions;
export default passiveLoadSlice.reducer;
